/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Changedefaultlabel2Inputs */

const id_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan`)
};

const ms_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan`)
};

const da_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændring`)
};

const de_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderung`)
};

const en_us2_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change`)
};

const es_es2_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio`)
};

const es_mx2_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio`)
};

const fil_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagbabago`)
};

const fr_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modification`)
};

const it_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica`)
};

const hu_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változás`)
};

const nl_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijziging`)
};

const no_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endring`)
};

const pl_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmiana`)
};

const pt_br2_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudar`)
};

const pt_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração`)
};

const ro_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificare`)
};

const fi_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutos`)
};

const sv_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändring`)
};

const vi_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi`)
};

const tr_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik`)
};

const cs_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změna`)
};

const bg_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промяна`)
};

const ru_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение`)
};

const uk_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зміна`)
};

const ar_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيير`)
};

const hi_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तन`)
};

const th_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปลี่ยนแปลง`)
};

const ja_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更`)
};

const zh_cn2_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更改`)
};

const zh_hant1_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`變更`)
};

const ko_sandboxes_changedefaultlabel2 = /** @type {(inputs: Sandboxes_Changedefaultlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경`)
};

/**
* | output |
* | --- |
* | "Change" |
*
* @param {Sandboxes_Changedefaultlabel2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_changedefaultlabel2 = /** @type {((inputs?: Sandboxes_Changedefaultlabel2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Changedefaultlabel2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_changedefaultlabel2(inputs)
	if (locale === "ms") return ms_sandboxes_changedefaultlabel2(inputs)
	if (locale === "da") return da_sandboxes_changedefaultlabel2(inputs)
	if (locale === "de") return de_sandboxes_changedefaultlabel2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_changedefaultlabel2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_changedefaultlabel2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_changedefaultlabel2(inputs)
	if (locale === "fil") return fil_sandboxes_changedefaultlabel2(inputs)
	if (locale === "fr") return fr_sandboxes_changedefaultlabel2(inputs)
	if (locale === "it") return it_sandboxes_changedefaultlabel2(inputs)
	if (locale === "hu") return hu_sandboxes_changedefaultlabel2(inputs)
	if (locale === "nl") return nl_sandboxes_changedefaultlabel2(inputs)
	if (locale === "no") return no_sandboxes_changedefaultlabel2(inputs)
	if (locale === "pl") return pl_sandboxes_changedefaultlabel2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_changedefaultlabel2(inputs)
	if (locale === "pt") return pt_sandboxes_changedefaultlabel2(inputs)
	if (locale === "ro") return ro_sandboxes_changedefaultlabel2(inputs)
	if (locale === "fi") return fi_sandboxes_changedefaultlabel2(inputs)
	if (locale === "sv") return sv_sandboxes_changedefaultlabel2(inputs)
	if (locale === "vi") return vi_sandboxes_changedefaultlabel2(inputs)
	if (locale === "tr") return tr_sandboxes_changedefaultlabel2(inputs)
	if (locale === "cs") return cs_sandboxes_changedefaultlabel2(inputs)
	if (locale === "bg") return bg_sandboxes_changedefaultlabel2(inputs)
	if (locale === "ru") return ru_sandboxes_changedefaultlabel2(inputs)
	if (locale === "uk") return uk_sandboxes_changedefaultlabel2(inputs)
	if (locale === "ar") return ar_sandboxes_changedefaultlabel2(inputs)
	if (locale === "hi") return hi_sandboxes_changedefaultlabel2(inputs)
	if (locale === "th") return th_sandboxes_changedefaultlabel2(inputs)
	if (locale === "ja") return ja_sandboxes_changedefaultlabel2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_changedefaultlabel2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_changedefaultlabel2(inputs)
	return ko_sandboxes_changedefaultlabel2(inputs)
});
export { sandboxes_changedefaultlabel2 as "sandboxes.changeDefaultLabel" }